import React, { useEffect } from "react";
import { Skeleton } from "antd";
import ProgramCards from "../ProgramCards";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../../api/module/httpClient";
import { INTERNAL_LINKS } from "../../../enum";

export default function FacultyCurrentDashboard({ setTab, userProfile, data = [], isFetching = false }) {

  useEffect(() => {
    setTab(0)
  }, []);

  return (
    <div>
      <div style={{ padding: "1rem 0" }}>
        {isFetching ? (
          <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
            {Array.from({ length: 3 }).fill(1).map((_, i) => (<Skeleton width={268} height={500} />))}
          </div>
        ) : (
          <div className='container-list-certificates'>
            {(data || []).map(program => <ProgramCards faculty={true} program={program} userProfile={userProfile} isDashboard={true} linkTo={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CLASS}/${program.slug}`} />)}
          </div>
        )}
      </div>
    </div>
  )
}

